import { css } from '@emotion/react';
import Mixin from '../../../util/mixin';


export class Transition extends Mixin {
  style({$}, [...transitions]) {
    if (transitions.length === 0) {
      transitions = $.transitionBase;
    }

    if (transitions.length > 1) {
      transitions.forEach($value => {
        if ($value == null || $value == "none") {
          console.warn("The keyword 'none' or 'null' must be used as a single argument.");
        }
      });
    }

    if ($.enableTransitions) {
      if (transitions[0] != null) {
        return css`transition: ${transitions.join(' ')};`;
      }

      if (
        $.enablePrefersReducedMotionMediaQuery && 
        transitions[0] != null && 
        transitions[0] != "none"
      ) {
        return css`@media (prefers-reduced-motion: reduce) {
          transition: none;
        }`
      }
    }
  }
}